const getAPIURLOfDomain = (domain: string): string => {
  if (domain === "www.doudizhu.online" || domain === "doudizhu.online") {
    return "https://api.doudizhu.online";
  }

  if (process.env.NEXT_PUBLIC_API_URL__LOCAL_ONLY !== undefined) {
    return process.env.NEXT_PUBLIC_API_URL__LOCAL_ONLY;
  }

  if (domain === "localhost") {
    return "http://localhost:8080";
  }
  throw new Error("API_URL could not be calculated.");
};

export const makeAPIURL = (): string => getAPIURLOfDomain(window.location.hostname);
